var _g, _g2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "route",
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.889,
    height: 51.889,
    viewBox: "0 0 51.889 51.889",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_589",
    "data-name": "Group 589",
    transform: "translate(0 27.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M13.783,293.282H7.6a4.561,4.561,0,0,1,0-9.121H21.485a6.081,6.081,0,1,0,0-12.161h-7.7v3.04h7.7a3.04,3.04,0,0,1,0,6.081H7.6a7.6,7.6,0,1,0,0,15.2H39.727l1.52-3.04Z",
    transform: "translate(0 -272)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_588",
    "data-name": "Group 588",
    transform: "translate(13.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M163.464,482H136v3.04h25.944Z",
    transform: "translate(-136 -460.718)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M143.7,284.161a6.081,6.081,0,1,0,0-12.161H136v3.04h7.7a3.04,3.04,0,0,1,0,6.081H136v3.04Z",
    transform: "translate(-136 -272)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_590",
    "data-name": "Group 590"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M18.343,0,15.3,3.04h-3.04L9.222,0H0V24.526H27.566V0Z",
    fill: "#e5a769"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M149.783,0h-9.222l-3.04,3.04H136V24.526h13.783Z",
    transform: "translate(-122.217)",
    fill: "#d17732"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M95.561,0H91V9.222h9.121V0Z",
    transform: "translate(-81.778)",
    fill: "#fff7cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M136,0h4.561V9.222H136Z",
    transform: "translate(-122.217)",
    fill: "#fd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M95.561,121H91v3.04h9.121V121Z",
    transform: "translate(-81.778 -108.737)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M136,121h4.561v3.04H136Z",
    transform: "translate(-122.217 -108.737)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M312.641,212A10.654,10.654,0,0,0,302,222.641c0,4.106,2.494,7.145,4.9,10.085,2.169,2.644,4.216,5.139,4.216,8.158v1.52h3.04v-1.52c0-3.018,2.047-5.514,4.216-8.158,2.411-2.939,4.9-5.978,4.9-10.085A10.654,10.654,0,0,0,312.641,212Zm0,15.2a4.561,4.561,0,1,1,4.561-4.561A4.566,4.566,0,0,1,312.641,227.2Z",
    transform: "translate(-271.394 -190.515)",
    fill: "#cf3030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M408.52,240.883c0-3.018,2.047-5.514,4.216-8.158,2.411-2.939,4.9-5.978,4.9-10.085A10.654,10.654,0,0,0,407,212v6.081a4.561,4.561,0,0,1,0,9.121v15.2h1.52Z",
    transform: "translate(-365.753 -190.515)",
    fill: "#ae1010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.7c15617d800c0273695e05f04061d393.svg";
export { ForwardRef as ReactComponent };